import { TrackProductService } from '@analytics/events';
import type {
  CommerceInsulation,
  TrackedProductComponent,
} from '@analytics/models';
import { FALLBACK_LIST_NAME } from '@analytics/utils';
import type { OnInit } from '@angular/core';
import { Component, Input } from '@angular/core';
import { componentViewModelSelector } from '@core/experience-editor-utils';
import { Store } from '@ngrx/store';
import includes from 'lodash/includes';
import type { InsulationProductWithCalculations } from '@innogy/feh/models';

import {
  InsulationProductTrackingConfig,
  confirmInsulationProductSelectionAction,
  insulationProductOverviewKey,
  selectInsulationProductOverviewViewModel,
  toggleInsulationProductSelectionAction,
} from '../../store';
import { mockInsulationProductOverviewViewModel } from '../../mocks/mock-insulation-product-overview-vm';
import { InsulationProductOverviewRendering } from '../../models/insulation-product-overview-rendering.interface';
import { initializeInsulationFunnelComponent } from '../../utils/initialize-insulation-funnel-component';

@Component({
  selector: 'wl-insulation-product-overview[rendering]',
  templateUrl: './insulation-product-overview.component.html',
})
export class InsulationProductOverviewComponent
  implements
    OnInit,
    TrackedProductComponent<
      InsulationProductWithCalculations,
      CommerceInsulation
    >
{
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering!: InsulationProductOverviewRendering;

  readonly viewModel$ = this.store$.select(
    componentViewModelSelector(
      selectInsulationProductOverviewViewModel,
      mockInsulationProductOverviewViewModel
    )
  );

  insulationProductOverviewKey = insulationProductOverviewKey;

  constructor(
    protected readonly store$: Store,
    private readonly trackingConfig: InsulationProductTrackingConfig,
    private readonly trackProductService: TrackProductService
  ) {}

  trackProductConfig = this.trackingConfig.config;

  ngOnInit() {
    this.store$.dispatch(
      initializeInsulationFunnelComponent(
        'productOverview',
        this.rendering.fields.FunnelSettings
      )
    );
  }

  stronglyTypedProduct(product: any) {
    return product as InsulationProductWithCalculations;
  }

  productSelected(
    selectedProducts: InsulationProductWithCalculations[],
    product: InsulationProductWithCalculations
  ) {
    return includes(selectedProducts, product);
  }

  toggleProduct(product: InsulationProductWithCalculations) {
    this.store$.dispatch(toggleInsulationProductSelectionAction({ product }));
  }

  submitClicked(
    event: Event,
    selectedProducts: InsulationProductWithCalculations[]
  ) {
    const listName =
      this.rendering.fields.componentName.value || FALLBACK_LIST_NAME;

    event.preventDefault();
    this.store$.dispatch(confirmInsulationProductSelectionAction());

    selectedProducts.forEach((product, index) => {
      this.trackProductService.trackSelection(
        this.trackProductConfig.mapToCommerce(product, {
          index,
          listName,
          numberOfProducts: 1,
        })
      );
    });
  }
}
